import { render } from "./partners-hackathon.vue?vue&type=template&id=2fbf626e&scoped=true"
import script from "./partners-hackathon.vue?vue&type=script&lang=js"
export * from "./partners-hackathon.vue?vue&type=script&lang=js"

import "./partners-hackathon.vue?vue&type=style&index=0&id=2fbf626e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2fbf626e"]])

export default __exports__